module.exports = __webpack_public_path__ + "static/media/Aly.df3e333f.jpeg";